import { useEffect, useState } from 'react';
import Resultats from '../../UI/Resultats.jsx';

function FranceInterRemerciement({
    interaction,
    resultatsVote,
    fetchResults
}) {

    /** Le traitement des participations par l'API est asynchrone récupérer le
     * résultat par interval est donc nécessaire pour obtenir le dernier résultat
     */
    useEffect(() => {
        if (interaction.show_results && fetchResults) {
            const interval = setInterval(fetchResults, 2500);
            return () => {
                clearInterval(interval);
            };
        }
    }, [interaction, fetchResults]);

    const [isDarkMode, setIsDarkMode] = useState('../../FranceInter/pouce_noir.svg');

    useEffect(() => {
        const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const handleChange = (e) => {
            setIsDarkMode(e.matches ? '../../FranceInter/pouce_noir.svg' : '../../FranceInter/pouce_blanc.svg');
        };

        if (darkModeMediaQuery.matches) {
            setIsDarkMode('../../FranceInter/pouce_blanc.svg');
        }

        darkModeMediaQuery.addEventListener('change', handleChange);

        return () => {
            darkModeMediaQuery.removeEventListener('change', handleChange);
        };
    }, []);


    return (
        <div className="custom-remerciement">
            {!interaction.show_results &&
                <>
                <img src={isDarkMode} alt="Un pouce en l'air pour valider montrer la validation." />
                    <p className="text text-particiation">Participation envoyée</p>
                    <p className="custom-text">{interaction.segment_customisation.text_thanks}</p>
                </>
            }

            {interaction.show_results && resultatsVote &&
                <>
                    <div>
                        <Resultats resultatsVote={resultatsVote} />
                    </div>
                </>
            }
        </div>

    )
}
export default FranceInterRemerciement;